module.exports = __webpack_public_path__ + "img/bean_black.761aabe4.svg";